var render, staticRenderFns
import script from "./RbLetter.vue?vue&type=script&lang=js"
export * from "./RbLetter.vue?vue&type=script&lang=js"
import style0 from "./RbLetter.vue?vue&type=style&index=0&id=732d1bee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports